export const periodFormat = (input?: string | Date | null): string | null => {
  if (!input) return null;
  const dateObj = typeof input === "string" ? new Date(input) : input;
  if (Number.isNaN(dateObj.getTime())) return null;
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  return `${year}${month}`;
};
